import React from 'react';
import styled from 'styled-components';
import { text } from '../../styling/mixins/typography';
import { span } from '../../styling/utils/grid';

const StyledLinkItem = styled.a`
  ${text('medium')}
  ${span(1)}
`;

const QuickSearchLinkItem = ({ name, url }) => {
  return (
    <StyledLinkItem className="text-medium" href={url}>
      {name}
    </StyledLinkItem>
  );
};

export default QuickSearchLinkItem;
